/**
 * 日本站 PC 产品详情页 — Banner 配置
 * 每个子产品(detailCode) 对应独立的背景图和提示语
 *
 * 结构：detailCode → { bgImage, subtitleKey }
 *   detailCode: URL 中的 detailName，即子产品的 code（fast / bulk / discts / delivery）
 *   subtitleKey: 对应 locales 中的 i18n key，由调用方用 $t 翻译
 *
 * 查找逻辑：
 *   1. detailCode 命中 → 返回对应配置
 *   2. detailCode 没匹配 → 返回 DEFAULT_BANNER（默认图 + 空 subtitle）
 */

const DEFAULT_BANNER = {
  bgImage: require('@/assets/img/class-delivery-banner-jp.png'),
  subtitleKey: '',
}

const jpBannerMap = {
  // 1 = 国際スピードサービス（国際快递）
  fast: {
    bgImage: require('@/assets/img/class-fast-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.fast.subtitle',
  },
  bulk: {
    bgImage: require('@/assets/img/class-bluk-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.bulk.subtitle',
  },
  discts: {
    bgImage: require('@/assets/img/class-disct-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.discts.subtitle',
  },
  plsc: {
    bgImage: require('@/assets/img/class-delivery-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.plsc.subtitle',
  },

  // 2 = 越境ECサービス（跨境电商）
  package: {
    bgImage: require('@/assets/img/class-delivery-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.package.subtitle',
  },
  delivery: {
    bgImage: require('@/assets/img/class-delivery-banner-jp.png'),
    subtitleKey: 'modules.jpProduct.banner.delivery.subtitle',
  },
}

/**
 * 根据 detailCode 获取 Banner 配置
 * @param {string} detailCode - 子产品的 code（URL 中的 detailName）
 * @returns {object} { bgImage, subtitleKey }
 */
export function getJpBannerConfig(detailCode) {
  if (detailCode && jpBannerMap[detailCode]) {
    return { ...jpBannerMap[detailCode] }
  }
  return { ...DEFAULT_BANNER }
}
